import type { Project } from '@/api/client';
import type { ContractorValueItem } from '@/components/ContractorCombo/ContractorCombo';

/**
 * Студия для email: первая studio у чтецов проекта (readers.studio_id).
 * Не выводится из project_contracts — там юрлица/договоры, не студии.
 */
export function getFirstStudioContractorFromProject(project: Project): ContractorValueItem | null {
  for (const reader of project.readers ?? []) {
    const studio = reader.studio;
    if (studio?.id && studio.name?.trim()) {
      return { id: studio.id, name: studio.name.trim() };
    }
  }
  return null;
}
